import { useNavigate } from 'react-router';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { AccountTypeCard } from './account-type-card';

type DemoDataConfig =
  | {
      isEnabled: false;
    }
  | {
      isEnabled: true;
      companyId: string;
    };

type OpenAccountSectionProps = {
  isLegalEntityInUk: boolean;
  demoDataConfig?: DemoDataConfig;
};

export const OpenAccountSection = ({
  isLegalEntityInUk,
  demoDataConfig = {
    isEnabled: false,
  },
}: OpenAccountSectionProps) => {
  const navigate = useNavigate();

  return (
    <Stack align="stretch" space={5} className="bg-white p-5">
      <Stack space={3}>
        <Inline justify="between" className="w-full">
          <h1 className="text-2xl font-semibold text-black">Add a new account</h1>

          {demoDataConfig.isEnabled && (
            <Inline className="gap-2">
              <Button
                variant="default"
                onClick={() => {
                  // EUR demo data via Revolut
                  const demoInstitutionData = {
                    name: 'Revolut',
                    logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png',
                  };
                  localStorage.setItem('selectedInstitution', JSON.stringify(demoInstitutionData));
                  window.location.href = `/api/gocardless/auth/${demoDataConfig.companyId}?ref=demo&demo=true`;
                }}
              >
                Generate demo data EUR
              </Button>

              <Button
                variant="default"
                onClick={() => {
                  // GBP demo data via HSBC
                  const demoInstitutionData = {
                    name: 'HSBC UK',
                    logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbc.png',
                  };
                  localStorage.setItem('selectedInstitution', JSON.stringify(demoInstitutionData));
                  window.location.href = `/api/gocardless/auth/${demoDataConfig.companyId}?ref=demo&demo=true&demoVariant=gbp_hsbc`;
                }}
              >
                Generate demo data GBP
              </Button>
            </Inline>
          )}
        </Inline>

        <p className="text-sm font-medium text-seapoint-gray-text">
          Below are a few ways to add an account to Seapoint. Choose which one you want to start with (you can always
          add other accounts later).
        </p>
      </Stack>

      <Inline space={5} align="stretch" justify="around" className="space-y-5 md:space-y-0">
        <AccountTypeCard config={{ accountType: 'EXTERNAL', onCtaClick: () => navigate('../connect-open-banking') }} />

        <AccountTypeCard config={{ accountType: 'SEAPOINT', isLegalEntityInUk }} />

        <AccountTypeCard config={{ accountType: 'TREASURY' }} />
      </Inline>
    </Stack>
  );
};
